import React from 'react';
import { formatCurrency } from '../../Utils/Formatters';
import { TbCircleFilled, TbInfoCircle } from 'react-icons/tb';
import Button from '../Form/Button';
import { useNavigate } from 'react-router-dom';

interface FidelityRegulationProps {
    company: any;
}

const FidelityRegulation = ({ company }: FidelityRegulationProps) => {

    const navigate = useNavigate();

    const currencyName = company.fidelity.currency_name || "Pontos";

    if (!company?.fidelity) return null;

    return (
        <div id="fidelity-regulation" className="w-full  flex flex-col gap-4">

            <div className="flex items-center gap-1 font-bold">
                <TbInfoCircle />
                <span>Regulamento</span>
            </div>

            <div className="w-full max-w-2xl px-4">
                <ul className="list-none text-sm space-y-2">
                    <li className="flex items-center gap-2 leading-none">
                        <TbCircleFilled size={8} className='text-custom-primary' />
                        <span>Você acumula pontos a partir de <strong className="text-gray-800">{formatCurrency(company.fidelity.minimum_order_value)}</strong> em compras.</span>
                    </li>
                    <li className="flex items-center gap-2 leading-none">
                        <TbCircleFilled size={8} className='text-custom-primary' />
                        <span>A cada <strong className="text-gray-800">{formatCurrency(company.fidelity.value_by_point)}</strong> em compras você acumula <strong className="text-gray-800">{company.fidelity.points_by_value} {currencyName}</strong>.</span>
                    </li>
                    <li className="flex items-center gap-2 leading-none">
                        <TbCircleFilled size={8} className='text-custom-primary' />
                        <span>1 {currencyName} equivale à <strong className="text-gray-800">{formatCurrency(company.fidelity.point_value)}</strong> em desconto nas suas compras.</span>
                    </li>
                </ul>

                {company.fidelity.regulation && (
                    <div className="mt-8 pt-8 border-t border-gray-100 prose prose-lg max-w-none text-gray-600" dangerouslySetInnerHTML={{ __html: company.fidelity.regulation }} />
                )}
            </div>

            <div className="flex flex-col items-center text-center gap-4 text-sm my-6 w-full">
                <p className='text-gray-400 italic leading-none'>*Atenção: as regras do programa de fidelidade podem sofrer alterações.</p>
                <Button onClick={() => navigate('/programa-de-fidelidade/termos-de-uso')} className=" w-fit">
                    Consulte aqui os termos de uso
                </Button>
            </div>
        </div>
    );
};

export default FidelityRegulation;
